import React from 'react'
import { Button } from '@mc/design-system'
import { usePrimaryCta } from '@mc/growth'
import {
  trackBogoCtaClicked,
  trackBogoNavigationClicked,
} from '@mc/pre-paywall-events'

export const Cta = () => {
  const { ctaHref, ctaCopy } = usePrimaryCta()

  const onClickPrimaryCta = () => {
    trackBogoNavigationClicked({
      action: ctaCopy,
      location: 'promotion-banner',
    })
    trackBogoCtaClicked({
      action: ctaCopy,
      href: ctaHref,
      location: 'promotion-banner',
    })
  }

  return (
    <Button size='sm' onClick={onClickPrimaryCta} as='a' href={ctaHref}>
      {ctaCopy}
    </Button>
  )
}
